module.exports = __webpack_public_path__ + "img/VelvetPetals.f829024c.jpg";